/**
 * Mock mode: `VITE_MOCK=1` at build/dev time turns it on by default; `?mock=1` / `?mock=0` in the URL overrides that
 * for the tab (remembered in sessionStorage), so one dev server can serve both mock and real sessions.
 */
function detect(): boolean {
  const envDefault = import.meta.env.VITE_MOCK === "1";
  // Deployed builds (sandbox, production) never switch to fake data from the URL.
  if (!import.meta.env.DEV) return envDefault;
  try {
    const q = new URLSearchParams(window.location.search).get("mock");
    if (q === "1" || q === "0") sessionStorage.setItem("icn_mock", q);
    const stored = sessionStorage.getItem("icn_mock");
    return stored === null ? envDefault : stored === "1";
  } catch {
    return envDefault;
  }
}

export const isMock = detect();
/** Public demo build: mock data only, sign in without a two-step code, any 6-digit code confirms. */
export const isDemo = isMock && import.meta.env.VITE_DEMO === "1";
/** Production = the production console's address (or an explicit build flag); everything else shows "Testnet". */
export const isProduction =
  import.meta.env.VITE_ENV === "production" || (typeof window !== "undefined" && window.location.hostname === "app.icryptonow.com");
